import styled from "styled-components";
import { Box } from "grid-styled";

import { space } from "metabase/styled-components/theme";

export const Container = styled(Box)`
  padding-bottom: ${space(4)};
`;
